// WHAT THE HOVER TOOLTIP SAYS ABOUT AN ELEMENT'S PRICE.
//
// Extracted from TimelineViewer so it can be tested. It used to be a closure
// inside the component, which is why the bug below survived: nothing could
// assert on it without rendering the whole viewer.
//
// THE BUG (owner, 2026-09-27: "hover pricing still not working correctly"):
// both price branches were gated on the CURRENCY SYMBOL as well as the price,
//
//   if (hoverMesh?.TotalPrice && neededTimeline?.currencysymb) { ... }
//
// so an element with a real price on a timeline that carries no symbol fell
// through to "unpriced item". A FORMATTING DETAIL WAS DECIDING A FACTUAL
// CLAIM. On prod that is 28 timelines, every one of them carrying an
// estimation value, across 16 projects including real customers.
//
// The symbol now affects only how the number is WRITTEN, never whether it is
// shown. A missing symbol prints the bare number, which is honest; it does
// NOT fall back to a dollar sign, because what the symbol should be when it is
// absent is a separate question that is deliberately not answered here - a
// wrong currency is worse than no currency, since a missing symbol looks like
// a bug and a wrong one looks like a number.
//
// THREE STATES, NOT TWO. "Nothing under the cursor" and "an element with no
// price" are different facts and used to give the same answer.
export const NOTHING_HOVERED = '';
export const UNPRICED = 'unpriced item';

export function hoverPriceLabel(hoverMesh, symbol, numeral) {
  if (!hoverMesh) return NOTHING_HOVERED;

  const sym = symbol || '';
  // THE SYMBOL IS PREFIXED HERE, NOT PASSED INTO numeral's FORMAT STRING.
  // numeral treats "$" as its own currency TOKEN and substitutes the locale's
  // symbol for it; any OTHER literal symbol in the format string is silently
  // DROPPED. So the old `${symbol} 0,0.00` rendered "$ 1,234.50" correctly and
  // rendered a euro or rupee timeline as a bare "1,234.50" with no symbol at
  // all - measured, not guessed. Formatting the number and prefixing the
  // symbol ourselves is the same output for dollars and a correct one for
  // everything else.
  //
  // This is about how a symbol is WRITTEN, not about which symbol is right -
  // that question is deliberately left alone.
  const money = (n) => `${sym}${sym ? ' ' : ''}${numeral(n).format('0,0.00')}`;

  if (hoverMesh.TotalPrice) return `Price :  ${money(hoverMesh.TotalPrice)}`;
  if (hoverMesh.UnitPrice && hoverMesh.Unit) {
    return `Price : ${money(hoverMesh.UnitPrice)}/${hoverMesh.Unit}`;
  }
  return UNPRICED;
}
